import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faFileAlt, faHandshake, faChartLine } from '@fortawesome/free-solid-svg-icons';
import HeroSection from '../components/HeroSection';
import ContactSection from '../components/ContactSection';

const InsurancePage: React.FC = () => {
  return (
    <>
      <HeroSection 
        title="विमा सेवा"
        subtitle="LIC कडून तुमच्या कुटुंबाचे संरक्षण आणि सुरक्षित भविष्यासाठी सर्वसमावेशक विमा योजना"
        buttonText="आमच्याशी संपर्क साधा"
        buttonLink="#contact"
      />
      
      <section className="section">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>जीवन आधार विमा सेवा केंद्र</h2>
              <p className="lead">तुमच्या सर्व विमा गरजांसाठी विश्वासार्ह भागीदार</p>
              <p>
                जीवन आधार विमा सेवा केंद्र येथे आम्ही जाणतो की प्रत्येक कुटुंबाच्या विमा गरजा वेगळ्या असतात. 
                आमचे तज्ञ सल्लागार तुमच्यासोबत काम करून तुम्हाला सर्वोत्कृष्ट संरक्षण योजना निवडण्यात मदत करतात.
              </p>
              <p>
                विमा क्षेत्रातील अनेक वर्षांचा अनुभव आणि LIC धोरणांचे सखोल ज्ञान आमच्याकडे आहे. 
                आम्ही वैयक्तिक मार्गदर्शन प्रदान करतो जेणेकरून तुम्ही तुमच्या कुटुंबाच्या आर्थिक सुरक्षिततेबाबत योग्य निर्णय घेऊ शकता.
              </p>
            </Col>
            <Col lg={6}>
              <div className="bg-light-gray p-4 rounded">
                <h4 className="mb-4">आम्हाला का निवडाल?</h4>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faShieldAlt} size="2x" />
                      </div>
                      <div>
                        <h5>संपूर्ण संरक्षण</h5>
                        <p className="mb-0">तुमच्या सर्व विमा गरजांसाठी व्यापक संरक्षण</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faFileAlt} size="2x" />
                      </div>
                      <div>
                        <h5>तज्ज्ञ मार्गदर्शन</h5>
                        <p className="mb-0">उद्योगातील तज्ञांकडून वैयक्तिक सल्ला</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faHandshake} size="2x" />
                      </div>
                      <div>
                        <h5>विश्वासार्ह सेवा</h5>
                        <p className="mb-0">तुमच्या पॉलिसीच्या संपूर्ण कालावधीत मदतीसाठी उपलब्ध</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="mb-3">
                    <div className="d-flex">
                      <div className="me-3 text-primary">
                        <FontAwesomeIcon icon={faChartLine} size="2x" />
                      </div>
                      <div>
                        <h5>गुंतवणूक नियोजन</h5>
                        <p className="mb-0">स्मार्ट वित्तीय नियोजनाद्वारे संपत्ती निर्माण</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="section bg-light-gray">
        <Container>
          <h2 className="section-title">आमच्या विमा सेवा</h2>
          <p className="section-subtitle">तुमच्या मन:शांतीसाठी संपूर्ण समाधान</p>
          
          <Row className="g-4 mt-4">
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>जीवन विमा</Card.Title>
                  <Card.Text>
                    आमच्या संपूर्ण जीवन विमा पॉलिसीद्वारे तुमच्या कुटुंबाच्या आर्थिक भवितव्याचे संरक्षण करा. 
                    टर्म लाईफ, संपूर्ण जीवन आणि एंडोमेंट योजना उपलब्ध आहेत.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>निवृत्ती योजना</Card.Title>
                  <Card.Text>
                    निवृत्तीनंतर तुमच्या जीवनशैलीत कोणतीही अडचण येऊ नये यासाठी आमच्या पेन्शन योजनांसह सुरक्षितता मिळवा.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>मुलांसाठी योजना</Card.Title>
                  <Card.Text>
                    तुमच्या मुलाच्या शिक्षण व लग्नाच्या महत्त्वाच्या टप्प्यांसाठी आवश्यक निधीची खात्री करून देणाऱ्या योजना.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>आरोग्य विमा</Card.Title>
                  <Card.Text>
                    अनपेक्षित वैद्यकीय खर्चापासून संरक्षण मिळवण्यासाठी संपूर्ण आरोग्य विमा योजना.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>गुंतवणूक योजना</Card.Title>
                  <Card.Text>
                    संरक्षणासह उत्पन्न देणाऱ्या विमा योजनांद्वारे तुमची संपत्ती वाढवा.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col lg={4} md={6}>
              <Card className="h-100">
                <Card.Body>
                  <Card.Title>गट विमा</Card.Title>
                  <Card.Text>
                    संस्थांसाठी कर्मचारी संरक्षण देणाऱ्या व्यापक गट विमा योजना.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      
      <ContactSection />
    </>
  );
};

export default InsurancePage;
